import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import useFontSize from '../../shell/hooks/useFontSize';
import { onChangeResolution } from '../../shell/utils/appManagementFunctions';
import { isMobile } from '../../shell/utils/platformCheck';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import menuSlice, { selectMenu, setSettings } from '../../store/slices/menuSlice';
import { parseRequire } from '../../utils/parseImageUrl';
import { SettingsButton } from './SettingsButton';
import { Slider } from './Slider';
import { throttle } from 'lodash';

interface SettingsProps {

}
export const Settings: React.FC<SettingsProps> = ({ }) => {
    const dispatch = useAppDispatch();
    const { width, height } = useDimensions().window;
    const [selected, setSelected] = useState(false);
    const size = useFontSize(7);
    const sliderRef = useRef();
    const { settings } = useAppSelector(selectMenu);
    const buttons = {
        SET_AFTER_CHOICES: parseRequire(require("@lss/common/game/assets/images/Menu/SET_AFTER_CHOICES.webp")),
        SET_FULL_SCREEN: parseRequire(require("@lss/common/game/assets/images/Menu/SET_FULL_SCREEN.webp")),
        SET_TRANSITION: parseRequire(require("@lss/common/game/assets/images/Menu/SET_TRANSITION.webp")),
        SET_UNSEEN_TEXT: parseRequire(require("@lss/common/game/assets/images/Menu/SET_UNSEEN_TEXT.webp")),
        SET_WINDOW: parseRequire(require("@lss/common/game/assets/images/Menu/SET_WINDOW.webp")),
        SET_TITLE_DISPLAY: parseRequire(require("@lss/common/game/assets/images/Menu/SET_TITLE_DISPLAY.webp")),
        SET_TITLE_SKIP: parseRequire(require("@lss/common/game/assets/images/Menu/SET_TITLE_SKIP.webp")),

    };
    const styles = StyleSheet.create({
        container: {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            paddingLeft: "10%",
            paddingRight: "10%"
            // alignItems: "flex-start",
            // justifyContent: "space-evenly",

        },
        settingsColumn: {
            // flexDirection: "column",
            // justifyContent: "flex-end"
        },
        titles: {
            // alignSelf: "flex-start",
            height: height / 10,
            width: width / 7,
        },
        radioButton: {
            // height: height / 13,
            // aspectRatio: 415 / 81

        },
        title: {
            zIndex: 1,
            fontFamily: "Ink Free",
            fontSize: useFontSize(6),
            fontWeight: "bold",
            color: "white",
        }


    });

    // useEffect(() => {
    //     if (settings.fullscreen) {
    //         onFullScreenPressed();
    //     }

    //     return () => {

    //     };
    // }, []);



    const onFullScreenPressed = () => {
        if (settings.fullscreen) { return; }
        onChangeResolution({ fullscreen: true });
    };
    const onWindowedPressed = () => {
        if (settings.windowed) { return; }
        onChangeResolution({ fullscreen: false });
    };
    const onSetUnseenPressed = () => {
        dispatch(setSettings({ skipUnseenText: !settings.skipUnseenText }));
    };
    const onSetTextOverlay = () => {
        dispatch(setSettings({ textOverlay: !settings.textOverlay }));
    };
    // const onMusicChange = (value: number) => {
    //     dispatch(setSettings({ musicVolume: value }));
    // };
    const onMusicChange = useCallback(throttle((value: number) => {
        dispatch(setSettings({ musicVolume: value }));
    }, 250), []); // Dependencies array is empty, so this callback is memoized once

    const onTextSkipValueChanged = useCallback(throttle((value: number) => {
        dispatch(setSettings({ skipSpeedValue: Math.abs(100 - value) }));
    }, 100), []); // Dependencies array is empty, so this callback is memoized once

    // const onTextSkipValueChanged = (value: number) => {

    //     dispatch(setSettings({ skipSpeedValue: Math.abs(100 - value) }));
    // };

    return (
        <View style={{
            display: "flex",
            flex: 0.7,
            alignItems: "center",
            justifyContent: "center",
        }}>
            <View style={styles.container}>
                {/* Display */}
                {!isMobile() ? <View style={styles.settingsColumn}>
                    {/* <Image style={styles.titles} source={buttons.SET_TITLE_DISPLAY} resizeMode={"contain"}></Image> */}
                    <Text style={styles.title}>Display</Text>

                    <SettingsButton text={`Full Screen`} checked={settings.fullscreen} onPress={() => onFullScreenPressed()} image={buttons.SET_FULL_SCREEN} />
                    <SettingsButton text={`Window`} checked={settings.windowed} onPress={() => onWindowedPressed()} image={buttons.SET_WINDOW} />
                    {/* <Image style={styles.radioButton} source={buttons.SET_WINDOW} resizeMode={"contain"}></Image> */}
                </View> : <></>}
                <View style={styles.settingsColumn}>
                    <Text style={styles.title}>Skip</Text>
                    {/* <Image style={styles.titles} source={buttons.SET_TITLE_SKIP} resizeMode={"contain"}></Image>
                <Image style={styles.radioButton} source={buttons.SET_UNSEEN_TEXT} resizeMode={"contain"}></Image> */}
                    {/* <Image style={styles.titles} source={buttons.SET_TITLE_SKIP} resizeMode={"contain"}></Image> */}
                    <SettingsButton text={`Unseen Text`} checked={settings.skipUnseenText} onPress={() => onSetUnseenPressed()} image={buttons.SET_UNSEEN_TEXT} />
                    <View style={styles.radioButton}></View>
                </View>
            </View>
            <View style={{ ...styles.container, marginTop: "5%" }}>
                {/* Display */}
                <View style={styles.settingsColumn}>
                    <Text style={styles.title}>Others</Text>
                    {/* <Image style={styles.titles} source={buttons.SET_TITLE_SKIP} resizeMode={"contain"}></Image>
                <Image style={styles.radioButton} source={buttons.SET_UNSEEN_TEXT} resizeMode={"contain"}></Image> */}
                    {/* <Image style={styles.titles} source={buttons.SET_TITLE_SKIP} resizeMode={"contain"}></Image> */}
                    <View>
                        <SettingsButton text={`Text overlay`} checked={settings.textOverlay} onPress={() => onSetTextOverlay()} image={buttons.SET_UNSEEN_TEXT} />
                        <View style={styles.radioButton}></View>
                    </View>
                    <View>
                    </View>
                </View>
                <View style={styles.settingsColumn}>
                    <Text style={styles.title}>Text skip speed</Text>
                    {/* <Image style={styles.titles} source={buttons.SET_TITLE_SKIP} resizeMode={"contain"}></Image>
                <Image style={styles.radioButton} source={buttons.SET_UNSEEN_TEXT} resizeMode={"contain"}></Image> */}
                    {/* <Image style={styles.titles} source={buttons.SET_TITLE_SKIP} resizeMode={"contain"}></Image> */}
                    <View>
                        <View style={{}}>
                            <Slider step={1} minimumValue={1} maximumValue={100} value={Math.abs(100 - settings.skipSpeedValue)}
                                onValueChange={(val) => onTextSkipValueChanged(val)} />
                            <Text style={{ ...styles.title, fontSize: useFontSize(3), alignSelf: "center" }}>{Math.abs(100 - settings.skipSpeedValue)}%</Text>
                        </View>
                    </View>
                </View>
            </View>





            {/* <View style={{ width: "50%" }}>
                <Text style={{ color: "white", fontSize: useFontSize(2.5) }}>MUSIC</Text>
                <Slider value={settings.musicVolume}
                    onValueChange={(val) => onMusicChange(val)}
                />
            </View> */}
        </View>
    );
};